import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { initialValuesPerson } from 'shell/constants/initial-values-search';

const WrapperPersonSearch = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesPerson}>
      <Outlet />
    </FilterTableProvider>
  );
};

WrapperPersonSearch.displayName = 'Page Person wrapper component';

export default WrapperPersonSearch;
